// Google Analytics configuration
import ReactGA from 'react-ga4';

// Tracking status
let isInitialized = false;

// Initialize GA4 with your measurement ID
export const initGA = (measurementId) => {
  if (!isInitialized) {
    // Initialize react-ga4 which will use the global gtag from the script in index.html
    ReactGA.initialize(measurementId, {
      gaOptions: {
        anonymizeIp: false // Don't anonymize IP addresses
      },
      // This option tells react-ga4 to use the existing gtag function
      useGlobalGtag: true
    });
    isInitialized = true;
    console.log('GA4 initialized for tracking with gtag');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (isInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
    console.log(`Pageview tracked: ${path}`);
    // Also track with global gtag for redundancy
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: path
      });
    }
  }
};

// Track events (e.g., button clicks, form submissions)
export const trackEvent = (category, action, label, value) => {
  if (isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
    console.log(`Event tracked: ${category} - ${action}`);
    // Also track with global gtag for redundancy
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  }
}; 